import { render, staticRenderFns } from "./FlowExporters.vue?vue&type=template&id=23c47d90"
import script from "./FlowExporters.vue?vue&type=script&lang=js"
export * from "./FlowExporters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports